<template>
  <div class="conten-title" >
    <span class="icon-icon_return_12 icon" @click="goback" v-if="showBack"></span>
    <span v-if="title !== ''">{{ title }}</span>
    <span class="right-action">
      <slot name="right-action"></slot>
    </span>
  </div>
</template>

<script >
export default {
  name: 'ContentTitle',
  props: {
    title: {
      type: String,
      default: ''
    },
    showBack: {
      type: Boolean,
      default: false
    },
    route: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
    }
  },
  components: {},
  computed: {},
  created () {},
  mounted () {},
  methods: {
    goback () {
      const route = this.route
      if (route) {
        this.$router.push(route)
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style lang='less' scoped>
.conten-title {
  position: relative;
    .icon {
      font-size: 12px;
      margin-right: 12px;
      color: #BBBBBB;
      cursor: pointer;
      &:hover{
        color: @primary-color;
      }
    }
    .right-action {
      position: absolute;
      right:24px;
      top: 17px;
    }
    color: #ff7401;
    font-size: 14px;
    padding: 17px 24px 17px 24px;
    border-bottom: 1px solid #f2f2f2;
    line-height: 1;
    background-color: #ffffff;
}
</style>
